(() => {
  const SECTION_CHUNK_SIZE = 5;
  const prefetchCache = new Map();
  const prefetchInFlight = new Map();
  let activeRequest = null;
  let bundleSwitchGeneration = 0;

  function clearSwitcherLoadingState(sectionId) {
    if (!sectionId) return;

    const switcher = document
      .getElementById(`shopify-section-${sectionId}`)
      ?.querySelector('bundle-variants-switcher');

    switcher?.setLoadingState(false, null);
  }

  function chunkArray(items, size) {
    const chunks = [];
    for (let i = 0; i < items.length; i += size) chunks.push(items.slice(i, i + size));
    return chunks;
  }

  function sectionIdFromElement(element) {
    return element.id.replace('shopify-section-', '');
  }

  function findReplacementSection(parsed, sectionId) {
    const sectionSelector = `#shopify-section-${sectionId}`;

    return (
      parsed.getElementById(`shopify-section-${sectionId}`) ||
      parsed.querySelector(sectionSelector) ||
      (parsed.body?.firstElementChild?.id === `shopify-section-${sectionId}` ? parsed.body.firstElementChild : null)
    );
  }

  function resolveNextSectionElement(sectionHtml, sectionId) {
    if (!sectionHtml) return null;

    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    let nextSection = findReplacementSection(parsed, sectionId);
    if (nextSection) return nextSection;

    const template = document.createElement('template');
    template.innerHTML = sectionHtml.trim();
    const root = template.content.firstElementChild;

    if (root?.id === `shopify-section-${sectionId}`) {
      return root;
    }

    const currentSection = document.getElementById(`shopify-section-${sectionId}`);
    if (currentSection && root) {
      const shell = currentSection.cloneNode(false);
      shell.innerHTML = root.outerHTML;
      return shell;
    }

    return null;
  }

  function applyVariantParam(requestUrl, trigger, variantId) {
    const resolvedVariantId = variantId || trigger?.getAttribute('data-bundle-product-variant-id');
    if (resolvedVariantId) {
      requestUrl.searchParams.set('variant', resolvedVariantId);
    }

    return requestUrl;
  }

  function getCurrentViewParam() {
    return (
      new URLSearchParams(window.location.search).get('view') ||
      window._template?.suffix ||
      ''
    );
  }

  function getPageSections() {
    let sections = Array.from(document.querySelectorAll('main .shopify-section[id^="shopify-section-"]'));

    if (!sections.length) {
      sections = Array.from(document.querySelectorAll('.shopify-section[id^="shopify-section-"]')).filter(
        (section) =>
          !section.classList.contains('shopify-section--header') &&
          !section.classList.contains('shopify-section--footer')
      );
    }

    return sections;
  }

  function executeInlineScripts(scope) {
    scope.querySelectorAll('script:not([src])').forEach((oldScript) => {
      const newScript = document.createElement('script');
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function syncPdpTableFromBundle() {
    const selectedItem = document.querySelector('.product-bundle-variants__item.is-selected');
    if (!selectedItem) return;

    const productName = selectedItem.querySelector('.product-bundle-variants__title');
    const productPrice = selectedItem.querySelector('.product-bundle-variants__price');
    const columnSubtitle = document.querySelector('.pdp-table__th-sub.c-coat_column_subtitle');
    const price = document.querySelector('.is--last-row .pdp-table__value--coat-cost');

    if (columnSubtitle && productName) {
      columnSubtitle.innerText = productName.innerText;
    }

    if (price && productPrice) {
      const newPrice = productPrice.innerText.trim();
      const match = newPrice.match(/[\d,.]+/);

      if (match) {
        let formattedPrice = Number.parseFloat(match[0].replace(',', ''));
        formattedPrice = Number.isInteger(formattedPrice) ? formattedPrice.toString() : formattedPrice.toFixed(2);
        price.innerHTML = price.innerHTML.replace(/[\d,.]+/, formattedPrice);
      }
    }
  }

  function syncAccordionExtras() {
    const accordionGroups = document.querySelectorAll('.product-info__block-group.accordion-group accordion-disclosure');

    accordionGroups.forEach((item) => {
      const customText = item.querySelector('.additional-content');
      const metafieldContent = item.querySelector('.metafield-rich_text_field');

      if (metafieldContent && customText) {
        const clonedContent = customText.cloneNode(true);
        clonedContent.style.display = '';
        metafieldContent.append(clonedContent);
      }
    });
  }

  async function fetchSectionsPayload(targetUrl, sectionIds, signal) {
    const chunks = chunkArray(sectionIds, SECTION_CHUNK_SIZE);
    const responses = await Promise.all(
      chunks.map(async (chunk) => {
        const requestUrl = new URL(targetUrl.toString());
        requestUrl.searchParams.set('sections', chunk.join(','));

        const response = await fetch(requestUrl.toString(), {
          signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Failed to fetch sections');
        return response.json();
      })
    );

    return responses.reduce((acc, payload) => Object.assign(acc, payload), {});
  }

  function parseMoneyToCents(moneyText) {
    if (!moneyText) return 0;
    const cleanPrice = moneyText.replace(/[^0-9.,]/g, '').replace(',', '.');
    const price = Number.parseFloat(cleanPrice);
    return Number.isNaN(price) ? 0 : Math.round(price * 100);
  }

  function formatSaveMoney(priceCents, compareCents) {
    if (!compareCents || compareCents <= priceCents) return '';
    const diff = compareCents - priceCents;
    let formatted = '';
    if (window.Shopify?.formatMoney) {
      const fmt =
        window.themeVariables?.settings?.moneyFormat || window.Shopify.money_format || '${{amount}}';
      formatted = window.Shopify.formatMoney(diff, fmt);
    } else {
      formatted = `$${(diff / 100).toFixed(2)}`;
    }
    return formatted.replace(/([.,])00(?!\d)/, '');
  }

  function parseSectionHtml(html) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function resolveBundleItemImageUrl(pill, item) {
    const pillImage = pill?.dataset.variantImage?.trim();
    if (pillImage) return pillImage;

    const imageWrap = item?.querySelector('.product-bundle-variants__image-wrap');
    return imageWrap?.dataset.bundleDefaultImage?.trim() || '';
  }

  function setBundleItemImage(item, imageUrl) {
    if (!item || !imageUrl) return;

    const imageWrap =
      item.querySelector('[data-bundle-image-wrap]') || item.querySelector('.product-bundle-variants__image-wrap');
    if (!imageWrap) return;

    const imageEl = imageWrap.querySelector('img.product-bundle-variants__image') || imageWrap.querySelector('img');

    if (imageEl) {
      imageEl.src = imageUrl;
      imageEl.removeAttribute('srcset');
      imageEl.removeAttribute('sizes');
      return;
    }

    imageWrap.innerHTML = `<img src="${imageUrl}" alt="" class="product-bundle-variants__image" loading="lazy">`;
  }

  function syncVariantPillsById(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-bundle-variant-pill]').forEach((pill) => {
      const isActive = pill.dataset.variantId === variantId;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function getOzValueFromPill(pill) {
    return String(pill?.dataset?.variantOzValue || '').trim();
  }

  function stripOzFromTitleText(currentTitle) {
    return String(currentTitle || '')
      .replace(/\s*[-–—]?\s*\d+\s*oz\.?\s*$/i, '')
      .trim();
  }

  function applyOzToTitleText(currentTitle, ozValue) {
    if (!currentTitle) return '';

    const baseTitle = stripOzFromTitleText(currentTitle);
    if (!ozValue) return baseTitle;

    return `${baseTitle} ${ozValue}`;
  }

  function updateTitleElementOz(element, ozValue) {
    if (!element) return;

    const titleTarget = element.querySelector?.('a') || element;
    const currentTitle = titleTarget.textContent.trim();
    if (!currentTitle) return;

    const nextTitle = applyOzToTitleText(currentTitle, ozValue);
    if (nextTitle === currentTitle) return;

    titleTarget.textContent = nextTitle;
  }

  function syncProductTitleFromVariantPill(pill) {
    const selectedItem = document.querySelector('.product-bundle-variants__item.is-selected');

    // Prefer the passed pill, else only the selected item's active pill (not other products / sticky).
    const sourcePill =
      pill || selectedItem?.querySelector('[data-bundle-variant-pill].is-active') || null;

    const ozValue = sourcePill ? getOzValueFromPill(sourcePill) : '';

    updateTitleElementOz(
      document.querySelector('.product-info__block-item--title-full .product-title'),
      ozValue
    );

    updateTitleElementOz(selectedItem?.querySelector('.product-bundle-variants__title'), ozValue);
    updateTitleElementOz(document.querySelector('[data-sticky-product-title]'), ozValue);
  }

  function syncTitlesOnLoad() {
    syncProductTitleFromVariantPill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTitlesOnLoad);
  } else {
    syncTitlesOnLoad();
  }

  function updateBundleItemPricesForItem(item, pill) {
    const priceCol = item?.querySelector('[data-bundle-price-col]');
    if (!priceCol || !pill) return;

    const priceEl = priceCol.querySelector('[data-bundle-price]');
    const compareEl = priceCol.querySelector('[data-bundle-compare-price]');
    const saveEl = priceCol.querySelector('[data-bundle-save]');
    const priceText = pill.dataset.variantPrice || '';
    const compareText = pill.dataset.variantCompare || '';

    if (priceEl && priceText) {
      priceEl.textContent = priceText;
      priceEl.hidden = false;
    }

    if (compareEl) {
      if (compareText) {
        compareEl.textContent = compareText;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (saveEl) {
      const saveMoney = formatSaveMoney(parseMoneyToCents(priceText), parseMoneyToCents(compareText));
      if (saveMoney) {
        saveEl.textContent = `You save ${saveMoney}`;
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }
  }

  function getFormVariantInput(form) {
    if (!form) return null;
    return form.querySelector('input[name="id"]') || (form.elements && form.elements.namedItem?.('id')) || null;
  }

  function getFormDomId(form) {
    if (!form) return '';
    return form?.getAttribute?.('id') || '';
  }

  function getProductFormsByDomId(formOrId) {
    const formDomId = typeof formOrId === 'string' ? formOrId : getFormDomId(formOrId);
    if (formDomId) {
      return Array.from(document.querySelectorAll(`form[id="${CSS.escape(formDomId)}"]`));
    }
    return formOrId ? [formOrId] : [];
  }

  function setFormVariantId(form, variantId, { emitChange = false } = {}) {
    if (!form || !variantId) return null;

    const forms = getProductFormsByDomId(form);
    if (!forms.length) return null;

    let primaryInput = null;

    forms.forEach((targetForm) => {
      targetForm.querySelectorAll('input[name="id"]').forEach((variantInput) => {
        const previousValue = String(variantInput.value);
        variantInput.disabled = false;
        variantInput.value = variantId;

        if (!primaryInput) primaryInput = variantInput;

        if (emitChange && previousValue !== String(variantId)) {
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    return primaryInput;
  }

  function updateStickyBarImageForForm(form, imageUrl) {
    if (!form || !imageUrl) return;

    const formDomId = getFormDomId(form);
    const stickyImg = document
      .querySelector(formDomId ? `product-sticky-bar[form="${formDomId}"]` : 'product-sticky-bar')
      ?.querySelector('.product-sticky-bar__thumb img');

    if (!stickyImg) return;

    stickyImg.src = imageUrl;
    stickyImg.removeAttribute('srcset');
    stickyImg.removeAttribute('sizes');
  }

  function updateBuyButtonPricesForForm(form, priceText, imageUrl) {
    if (!form || !priceText) return;

    const forms = getProductFormsByDomId(form);
    const targets = forms.length ? forms : [form];

    targets.forEach((targetForm) => {
      const buttonPrice = targetForm.querySelector('[data-buy-button-price]');
      const buttonSeparator = targetForm.querySelector('[data-buy-button-separator]');
      if (buttonPrice) buttonPrice.textContent = priceText;
      if (buttonSeparator) buttonSeparator.hidden = false;
    });

    const formDomId = getFormDomId(form);
    const stickyRoot = document.querySelector(
      formDomId ? `product-sticky-bar[form="${formDomId}"]` : 'product-sticky-bar'
    );
    const stickyPrice = stickyRoot?.querySelector('[data-sticky-atc-price]');
    const stickySeparator = stickyRoot?.querySelector('[data-sticky-atc-separator]');
    const stickyMetaPrice = stickyRoot?.querySelector('[data-sticky-meta-price]');

    if (stickyPrice) stickyPrice.textContent = priceText;
    if (stickySeparator) stickySeparator.hidden = false;
    if (stickyMetaPrice) stickyMetaPrice.textContent = priceText;
    if (imageUrl) updateStickyBarImageForForm(form, imageUrl);

    const subsWidget = document.querySelector('custom-subscription-widget');
    if (subsWidget) {
      subsWidget.querySelector('[data-subscription-mode="otp"]')?.setAttribute('data-otp-price', priceText);
      const otpPrice = subsWidget.querySelector(
        '.custom-subscription-widget__option-otp .custom-subscription-widget__price'
      );
      if (otpPrice) otpPrice.textContent = priceText;
    }
  }

  function findProductGalleryInRoot(root, formId) {
    if (!root) return null;

    if (formId) {
      const byForm = root.querySelector(`product-gallery[form="${formId}"]`);
      if (byForm) return byForm;
    }

    return root.querySelector('product-gallery.product-gallery-pdp-new-temp');
  }

  function replaceProductGalleryFromSection(sectionHtml, formId, sectionId) {
    if (!sectionHtml) return false;

    const parsed = typeof sectionHtml === 'string' ? parseSectionHtml(sectionHtml) : sectionHtml;
    if (!parsed) return false;

    const currentGallery = findProductGalleryInRoot(document, formId);
    let nextGallery = findProductGalleryInRoot(parsed, formId);

    if (!nextGallery && sectionId) {
      const sectionRoot =
        parsed.getElementById(`shopify-section-${sectionId}`) || parsed.querySelector(`[id^="shopify-section-"]`);
      nextGallery = findProductGalleryInRoot(sectionRoot, formId);
    }

    if (!currentGallery || !nextGallery) return false;

    currentGallery.replaceWith(nextGallery);
    executeInlineScripts(nextGallery);
    return true;
  }

  function replaceSubscriptionWidgetFromFragment(htmlFragment) {
    const currentWidget = document.querySelector('custom-subscription-widget');
    const nextWidget = htmlFragment.querySelector('custom-subscription-widget');
    if (!currentWidget || !nextWidget) return;

    const wasSubscription = currentWidget.classList.contains('mode-subscription');
    const activePlanId =
      currentWidget.querySelector('[data-selling-plan-id].is-active')?.dataset.sellingPlanId || '';

    currentWidget.replaceWith(nextWidget);

    const restoredWidget = document.querySelector('custom-subscription-widget');
    if (!restoredWidget || !wasSubscription) return;

    const planPill =
      (activePlanId && restoredWidget.querySelector(`[data-selling-plan-id="${activePlanId}"]`)) ||
      restoredWidget.querySelector('[data-selling-plan-id]');

    if (planPill && typeof restoredWidget.applyMode === 'function') {
      if (typeof restoredWidget.setActivePlan === 'function') {
        restoredWidget.setActivePlan(planPill);
      }
      restoredWidget.applyMode('subscription');
    }
  }

  function syncSelectedBundleItemFromParsedSection(parsedSection) {
    if (!parsedSection) return;

    const nextBundle = parsedSection.querySelector('bundle-variants-switcher');
    const currentBundle = document.querySelector('bundle-variants-switcher');
    if (!nextBundle || !currentBundle) return;

    const nextSelected = nextBundle.querySelector('.product-bundle-variants__item.is-selected');
    const currentSelected = currentBundle.querySelector('.product-bundle-variants__item.is-selected');
    if (!nextSelected || !currentSelected) return;

    const nextImageWrap = nextSelected.querySelector('.product-bundle-variants__image-wrap');
    const currentImageWrap = currentSelected.querySelector('.product-bundle-variants__image-wrap');

    if (nextImageWrap && currentImageWrap) {
      currentImageWrap.innerHTML = nextImageWrap.innerHTML;
      if (nextImageWrap.dataset.bundleDefaultImage) {
        currentImageWrap.dataset.bundleDefaultImage = nextImageWrap.dataset.bundleDefaultImage;
      }
    } else if (nextImageWrap && !currentImageWrap) {
      const body = currentSelected.querySelector('.product-bundle-variants__body') || currentSelected;
      const radio = body.querySelector('.product-bundle-variants__radio');
      if (radio) {
        radio.insertAdjacentHTML('afterend', nextImageWrap.outerHTML);
      } else {
        body.insertAdjacentHTML('afterbegin', nextImageWrap.outerHTML);
      }
    } else if (!nextImageWrap && currentImageWrap) {
      currentImageWrap.remove();
    }
  }

  async function switchProductVariant({ pill, productUrl, form, sectionId, bundleItem, updateGallery, requestUrl }) {
    const variantId = pill.dataset.variantId;
    const fetchBaseUrl = requestUrl || productUrl;

    if (!variantId || !fetchBaseUrl || !sectionId || !form) return;

    const forms = getProductFormsByDomId(form);
    const formAlreadySelected =
      forms.length > 0 &&
      forms.every((targetForm) => {
        const inputs = [...targetForm.querySelectorAll('input[name="id"]')];
        return inputs.length > 0 && inputs.every((input) => String(input.value) === String(variantId));
      });
    const pillAlreadyActive = pill.classList.contains('is-active');

    if (pillAlreadyActive && formAlreadySelected) return;

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    pill.disabled = true;
    syncVariantPillsById(variantId);
    setFormVariantId(form, variantId, { emitChange: true });

    const bundleItemEl = bundleItem?.classList?.contains('product-bundle-variants__item') ? bundleItem : null;
    if (bundleItemEl) {
      const imageUrl = resolveBundleItemImageUrl(pill, bundleItemEl);
      setBundleItemImage(bundleItemEl, imageUrl);
    }

    try {
      const sectionHtml = await fetchProductSectionHtml(fetchBaseUrl, variantId, sectionId, activeRequest.signal);
      const parsedSection = parseSectionHtml(sectionHtml);
      const htmlFragment = document.createRange().createContextualFragment(sectionHtml);

      setFormVariantId(form, variantId);

      form.dispatchEvent(
        new CustomEvent('product:rerender', {
          detail: {
            htmlFragment,
            productChange: false
          }
        })
      );

      const formDomId = getFormDomId(form);
      const liveForm = (formDomId && document.getElementById(formDomId)) || form;
      setFormVariantId(liveForm, variantId, { emitChange: true });

      replaceSubscriptionWidgetFromFragment(htmlFragment);

      if (updateGallery) {
        replaceProductGalleryFromSection(parsedSection || sectionHtml, formDomId || getFormDomId(liveForm), sectionId);
        syncSelectedBundleItemFromParsedSection(parsedSection);
      }

      const newVariant = JSON.parse(
        (parsedSection || htmlFragment).querySelector('script[data-variant]')?.textContent || '{}'
      );

      liveForm.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: {
            formId: getFormDomId(liveForm),
            variant: newVariant?.id ? newVariant : { id: Number(variantId) || variantId }
          }
        })
      );

      if (bundleItemEl) {
        updateBundleItemPricesForItem(bundleItemEl, pill);
      }

      const variantImageUrl = resolveBundleItemImageUrl(pill, bundleItemEl || pill.closest('[data-sticky-atc-variants]'));
      updateStickyBarImageForForm(liveForm, variantImageUrl);

      const subsWidget = document.querySelector('custom-subscription-widget');
      if (!subsWidget?.classList.contains('mode-subscription')) {
        updateBuyButtonPricesForForm(liveForm, pill.dataset.variantPrice, variantImageUrl);
      }

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variantId);
      window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());

      syncProductTitleFromVariantPill(pill);
      document.dispatchEvent(new CustomEvent('bundle:variant-change'));
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[bundle-variants] Variant switch failed', error);
        const formDomId = getFormDomId(form);
        setFormVariantId((formDomId && document.getElementById(formDomId)) || form, variantId);
      }
    } finally {
      pill.disabled = pill.dataset.variantAvailable === 'false';
    }
  }

  function extractSectionHtmlFromPayload(payload, sectionId) {
    if (!payload) return '';
    if (typeof payload === 'string') return payload;
    if (!payload || typeof payload !== 'object') return '';

    if (payload[sectionId]) return payload[sectionId];

    const keys = Object.keys(payload);
    if (keys.length === 1) return payload[keys[0]];

    const matchingKey = keys.find((key) => key === sectionId || key.endsWith(sectionId));
    return matchingKey ? payload[matchingKey] : '';
  }

  function isValidSectionPayload(payload, sectionIds) {
    return sectionIds.some((sectionId) => Boolean(extractSectionHtmlFromPayload(payload, sectionId)));
  }

  async function fetchProductSectionHtml(productUrl, variantId, sectionId, signal) {
    const sectionsUrl = new URL(productUrl, window.location.origin);
    sectionsUrl.searchParams.set('variant', variantId);
    sectionsUrl.searchParams.set('sections', sectionId);

    const sectionsResponse = await fetch(sectionsUrl.toString(), {
      signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (sectionsResponse.ok) {
      const contentType = sectionsResponse.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const payload = await sectionsResponse.json();
        const html = extractSectionHtmlFromPayload(payload, sectionId);
        if (html) return html;
      } else {
        const html = await sectionsResponse.text();
        if (html) return html;
      }
    }

    const sectionUrl = new URL(productUrl, window.location.origin);
    sectionUrl.searchParams.set('variant', variantId);
    sectionUrl.searchParams.set('section_id', sectionId);

    const sectionResponse = await fetch(sectionUrl.toString(), {
      signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!sectionResponse.ok) throw new Error('Failed to fetch product section');
    return sectionResponse.text();
  }

  class BundleVariantsSwitcher extends HTMLElement {
    get showProductVariants() {
      return this.dataset.showProductVariants === 'true';
    }

    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onPrefetchIntent = this.onPrefetchIntent.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('pointerenter', this.onPrefetchIntent, true);
      this.addEventListener('focusin', this.onPrefetchIntent);
      this.addEventListener('touchstart', this.onPrefetchIntent, { passive: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('pointerenter', this.onPrefetchIntent, true);
      this.removeEventListener('focusin', this.onPrefetchIntent);
      this.removeEventListener('touchstart', this.onPrefetchIntent);
    }

    getForm() {
      return this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
    }

    getSectionId() {
      const sectionEl = this.closest('[id^="shopify-section-"]');
      if (sectionEl) return sectionEl.id.replace('shopify-section-', '');

      if (this.dataset.sectionId) return this.dataset.sectionId;

      const formId = this.dataset.formId || '';
      const match = formId.match(/^product-form-(?:main|featured)-\d+-(.+)$/);
      return match?.[1] || '';
    }

    isSectionScope() {
      return this.dataset.switchScope === 'section';
    }

    getTargetSections() {
      if (this.isSectionScope()) {
        const section = this.closest('[id^="shopify-section-"]');
        return section ? [section] : [];
      }

      return getPageSections();
    }

    buildRequestUrl(trigger, variantId) {
      const requestUrl = applyVariantParam(
        new URL(trigger.getAttribute('data-bundle-product-url'), window.location.origin),
        trigger,
        variantId
      );

      const view = getCurrentViewParam();
      if (view) requestUrl.searchParams.set('view', view);

      return requestUrl;
    }

    buildCacheKey(requestUrl, sectionIds) {
      return `${requestUrl.pathname}${requestUrl.search}::${sectionIds.join(',')}`;
    }

    setLoadingState(isLoading, activeTrigger) {
      this.classList.toggle('is-loading', isLoading);
      this.setAttribute('aria-busy', isLoading ? 'true' : 'false');

      this.querySelectorAll('[data-bundle-product-url]').forEach((trigger) => {
        if (trigger.tagName === 'BUTTON') {
          trigger.disabled = isLoading;
        } else {
          trigger.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        }
        trigger.classList.toggle('is-loading', isLoading && trigger === activeTrigger);
      });
    }

    async onPrefetchIntent(event) {
      const trigger = event.target.closest('[data-bundle-product-url]');
      if (!trigger || !this.contains(trigger)) return;

      const sections = this.getTargetSections();
      const sectionIds = sections.map(sectionIdFromElement).filter(Boolean);
      if (!sectionIds.length) return;

      const requestUrl = this.buildRequestUrl(trigger);
      const cacheKey = this.buildCacheKey(requestUrl, sectionIds);

      if (prefetchCache.has(cacheKey) || prefetchInFlight.has(cacheKey)) return;

      const fetchPromise = fetchSectionsPayload(requestUrl, sectionIds)
        .then((payload) => {
          if (isValidSectionPayload(payload, sectionIds)) {
            prefetchCache.set(cacheKey, payload);
          }
          prefetchInFlight.delete(cacheKey);
        })
        .catch(() => {
          prefetchInFlight.delete(cacheKey);
        });

      prefetchInFlight.set(cacheKey, fetchPromise);
    }

    async switchBundleProduct(trigger, variantId) {
      const url = trigger.getAttribute('data-bundle-product-url');
      if (!url) return;

      if (this.isSectionScope() && trigger.classList.contains('is-selected')) return;

      const currentView = getCurrentViewParam();

      if (!this.isSectionScope()) {
        const targetUrl = new URL(url, window.location.origin);

        if (this.showProductVariants && variantId) {
          targetUrl.searchParams.set('variant', variantId);
        } else if (!this.showProductVariants) {
          targetUrl.searchParams.delete('variant');
        }

        if (targetUrl.pathname === window.location.pathname && targetUrl.search === window.location.search) {
          return;
        }

        const productUrl = new URL(url, window.location.origin);
        if (productUrl.pathname === window.location.pathname && productUrl.search === window.location.search) return;
      }

      const sections = this.getTargetSections();
      if (!sections.length) return;

      const sectionIds = sections.map(sectionIdFromElement).filter(Boolean);
      if (!sectionIds.length) return;

      const requestUrl = this.buildRequestUrl(trigger, variantId);
      const cacheKey = this.buildCacheKey(requestUrl, sectionIds);
      const generation = ++bundleSwitchGeneration;

      if (activeRequest) activeRequest.abort();
      activeRequest = new AbortController();

      this.setLoadingState(true, trigger);
      document.dispatchEvent(new CustomEvent('bundle:before-switch'));

      try {
        let payload = prefetchCache.get(cacheKey);

        if (!payload) {
          payload = await fetchSectionsPayload(requestUrl, sectionIds, activeRequest.signal);
        }

        if (!isValidSectionPayload(payload, sectionIds)) {
          prefetchCache.delete(cacheKey);
          throw new Error('Section payload missing expected HTML');
        }

        let replacedCount = 0;

        sections.forEach((currentSection) => {
          const sectionId = sectionIdFromElement(currentSection);
          const sectionHtml = extractSectionHtmlFromPayload(payload, sectionId);
          const nextSection = resolveNextSectionElement(sectionHtml, sectionId);
          if (!nextSection) return;

          currentSection.replaceWith(nextSection);
          executeInlineScripts(nextSection);
          replacedCount += 1;
        });

        if (!replacedCount) {
          prefetchCache.delete(cacheKey);
          throw new Error('No sections were replaced');
        }

        prefetchCache.set(cacheKey, payload);

        const selectedItem = document.querySelector('.product-bundle-variants__item.is-selected');

        if (selectedItem) {
          const productName = selectedItem.querySelector('.product-bundle-variants__title');
          const columnSubtitle = document.querySelector('.pdp-table__th-sub.c-coat_column_subtitle');

          if (columnSubtitle && productName) {
            columnSubtitle.innerText = productName.innerText;
          }
        }

        if (this.showProductVariants && variantId) {
          const switcher = document.querySelector('bundle-variants-switcher');
          const liveForm =
            (switcher?.dataset?.formId && document.getElementById(switcher.dataset.formId)) ||
            this.getForm() ||
            document.querySelector('form[id^="product-form"]');
          setFormVariantId(liveForm, variantId);
        }

        if (!this.isSectionScope()) {
          syncPdpTableFromBundle();
          syncAccordionExtras();
          const productUrl = new URL(trigger.getAttribute('data-bundle-product-url'), window.location.origin);
          if (currentView) productUrl.searchParams.set('view', currentView);
          if (this.showProductVariants && variantId) {
            productUrl.searchParams.set('variant', variantId);
          }
          window.history.pushState({ bundleVariant: true }, '', productUrl.pathname + productUrl.search);
        } else {
          const historyUrl = new URL(window.location.href);
          const handle = trigger.getAttribute('data-bundle-product-handle');

          historyUrl.searchParams.delete('product');
          historyUrl.searchParams.delete('bundle_product');
          historyUrl.searchParams.delete('variant');

          if (handle) {
            historyUrl.searchParams.set('bundle_product', handle);
          }

          if (this.showProductVariants && variantId) {
            historyUrl.searchParams.set('variant', variantId);
          }

          window.history.pushState({ bundleVariant: true }, '', historyUrl.pathname + historyUrl.search);
        }

        document.dispatchEvent(new CustomEvent('bundle:after-switch'));
        if (this.showProductVariants) {
          const selectedBundleItem = document.querySelector('.product-bundle-variants__item.is-selected');
          const activePill = variantId
            ? selectedBundleItem?.querySelector(
                `[data-bundle-variant-pill][data-variant-id="${variantId}"]`
              ) ||
              selectedBundleItem?.querySelector('[data-bundle-variant-pill].is-active')
            : selectedBundleItem?.querySelector('[data-bundle-variant-pill].is-active');
          syncProductTitleFromVariantPill(activePill);
          document.dispatchEvent(new CustomEvent('bundle:variant-change'));
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          prefetchCache.delete(cacheKey);
          console.error('[bundle-variants] Switch failed', error);
        }
      } finally {
        if (generation === bundleSwitchGeneration) {
          clearSwitcherLoadingState(sectionIds[0]);
        }
      }
    }

    setActiveVariantPill(_item, targetPill) {
      syncVariantPillsById(targetPill?.dataset.variantId);
    }

    updateBundleItemImage(item, pill) {
      const imageUrl = resolveBundleItemImageUrl(pill, item);
      setBundleItemImage(item, imageUrl);
    }

    syncSelectedBundleItemFromSection(parsedSection) {
      if (!parsedSection) return;

      const nextBundle = parsedSection.querySelector('bundle-variants-switcher');
      const currentBundle = document.querySelector('bundle-variants-switcher');
      if (!nextBundle || !currentBundle) return;

      const nextSelected = nextBundle.querySelector('.product-bundle-variants__item.is-selected');
      const currentSelected = currentBundle.querySelector('.product-bundle-variants__item.is-selected');
      if (!nextSelected || !currentSelected) return;

      const nextImageWrap = nextSelected.querySelector('.product-bundle-variants__image-wrap');
      const currentImageWrap = currentSelected.querySelector('.product-bundle-variants__image-wrap');

      if (nextImageWrap && currentImageWrap) {
        currentImageWrap.innerHTML = nextImageWrap.innerHTML;
        if (nextImageWrap.dataset.bundleDefaultImage) {
          currentImageWrap.dataset.bundleDefaultImage = nextImageWrap.dataset.bundleDefaultImage;
        }
      } else if (nextImageWrap && !currentImageWrap) {
        const body = currentSelected.querySelector('.product-bundle-variants__body') || currentSelected;
        const radio = body.querySelector('.product-bundle-variants__radio');
        if (radio) {
          radio.insertAdjacentHTML('afterend', nextImageWrap.outerHTML);
        } else {
          body.insertAdjacentHTML('afterbegin', nextImageWrap.outerHTML);
        }
      } else if (!nextImageWrap && currentImageWrap) {
        currentImageWrap.remove();
      }
    }

    updateBundleItemPrices(item, pill) {
      updateBundleItemPricesForItem(item, pill);
    }

    updateStickyBarImage(imageUrl) {
      updateStickyBarImageForForm(this.getForm(), imageUrl);
    }

    updateBuyButtonPrices(priceText, imageUrl) {
      updateBuyButtonPricesForForm(this.getForm(), priceText, imageUrl);
    }

    findProductGallery(root) {
      if (!root) return null;

      const form = this.getForm();
      const formDomId = getFormDomId(form);
      if (formDomId) {
        const byForm = root.querySelector(`product-gallery[form="${formDomId}"]`);
        if (byForm) return byForm;
      }

      return root.querySelector('product-gallery.product-gallery-pdp-new-temp');
    }

    replaceProductGallery(sectionHtml) {
      return replaceProductGalleryFromSection(sectionHtml, getFormDomId(this.getForm()), this.getSectionId());
    }

    replaceSubscriptionWidget(htmlFragment) {
      replaceSubscriptionWidgetFromFragment(htmlFragment);
    }

    async selectVariantOnCurrentProduct(pill, item, options = {}) {
      const productUrl = item?.getAttribute?.('data-bundle-product-url') || item?.dataset?.bundleProductUrl;
      const requestUrl = this.isSectionScope() && item ? this.buildRequestUrl(item).toString() : undefined;

      await switchProductVariant({
        pill,
        productUrl,
        requestUrl,
        form: this.getForm(),
        sectionId: this.getSectionId(),
        bundleItem: item,
        updateGallery: options.updateGallery ?? this.showProductVariants
      });
    }

    async onClick(event) {
      if (this.showProductVariants) {
        const variantPill = event.target.closest('[data-bundle-variant-pill]');
        if (variantPill && this.contains(variantPill)) {
          event.preventDefault();
          event.stopPropagation();

          const item = variantPill.closest('.product-bundle-variants__item');
          if (!item) return;

          if (item.classList.contains('is-selected')) {
            await this.selectVariantOnCurrentProduct(variantPill, item);
          } else {
            await this.switchBundleProduct(item, variantPill.dataset.variantId);
          }
          return;
        }
      }

      const trigger = event.target.closest('[data-bundle-product-url]');
      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();
      await this.switchBundleProduct(trigger);
    }
  }

  class StickyAtcVariants extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    getForm() {
      const formId = this.dataset.formId;
      return document.getElementById(formId) || document.forms[formId];
    }

    getBundleSwitcher() {
      const formId = this.dataset.formId;
      return (
        document.querySelector(`bundle-variants-switcher[data-form-id="${formId}"]`) ||
        document.querySelector('bundle-variants-switcher')
      );
    }

    async onClick(event) {
      const pill = event.target.closest('[data-bundle-variant-pill]');
      if (!pill || !this.contains(pill)) return;

      event.preventDefault();
      event.stopPropagation();

      if (pill.classList.contains('is-active')) return;

      const bundleItem = document.querySelector('.product-bundle-variants__item.is-selected');
      const switcher = this.getBundleSwitcher();

      if (switcher) {
        await switcher.selectVariantOnCurrentProduct(pill, bundleItem || this, { updateGallery: true });
        return;
      }

      await switchProductVariant({
        pill,
        productUrl: this.dataset.bundleProductUrl,
        form: this.getForm(),
        sectionId: this.dataset.sectionId,
        bundleItem,
        updateGallery: true
      });
    }
  }

  if (!window.customElements.get('sticky-atc-variants')) {
    window.customElements.define('sticky-atc-variants', StickyAtcVariants);
  }

  if (!window.customElements.get('bundle-variants-switcher')) {
    window.customElements.define('bundle-variants-switcher', BundleVariantsSwitcher);
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  const selectedItem = document.querySelector('.product-bundle-variants__item.is-selected');

  if (selectedItem) {
    const productName = selectedItem.querySelector('.product-bundle-variants__title');

    const columnSubtitle = document.querySelector('.pdp-table__th-sub.c-coat_column_subtitle');

    if (columnSubtitle && productName) {
      columnSubtitle.innerText = productName.innerText;
    }
  }

  const accordionGroups = document.querySelectorAll('.product-info__block-group.accordion-group accordion-disclosure');

  accordionGroups.forEach(item => {
    const customText = item.querySelector('.additional-content');
    const metafieldContent = item.querySelector('.metafield-rich_text_field');

    if (metafieldContent && customText) {
      const clonedContent = customText.cloneNode(true);

      clonedContent.style.display = '';

      metafieldContent.append(clonedContent);
    }
  });
});
